module.exports = __webpack_public_path__ + "img/packages20_product_banner.44e6e510.gif";